import Image from 'next/image';
import { buildCssVar } from 'utils/style-override';
import { buildImgProps } from 'utils/media';

import type { ComponentsHeaderLogo } from 'queries/graphql';

import styles from './styles.module.scss';

export default function HeaderLogo({ image, secondImage, style }: ComponentsHeaderLogo) {
  const { backgroundColor } = style || {};

  return (
    <header className={`root ${styles.container}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
        }
      `}</style>
      <div className={styles.header}>
        <div
          className={`${styles.logo} ${
            secondImage ? styles.side_aligned_items : styles.centered_item
          }`}
        >
          <div className={styles.img_wrapper}>
            <Image {...buildImgProps(image)} alt={image?.alt || 'Logo'} />
          </div>

          {secondImage && (
            <div className={styles.img_wrapper}>
              <Image {...buildImgProps(secondImage)} alt={secondImage?.alt || 'Logo'} />
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
